/* eslint-disable no-undef */
(function (window) {
	"use strict";
	function defineSideMenuLinksHelper() {
		var sideMenuLinksHelper = {};
		sideMenuLinksHelper.updateActiveLinks = function(){
			console.log("Update links");
			$("#side-menu a").each(function () {
				$(this).attr("aria-expanded", false);
				$(this).parent().removeClass("mm-active"); // add active to li of the current link
				$(this).parent().parent().removeClass("mm-show");
				//$(this).parent().parent().prev().addClass("active"); // add active class to an anchor
				$(this).parent().parent().prev().attr("aria-expanded", false);
				$(this).parent().parent().parent().removeClass("mm-active");
				$(this).parent().parent().parent().parent().removeClass("mm-show"); // add active to li of the current link
				$(this).parent().parent().parent().parent().prev().attr("aria-expanded", false);
				$(this).parent().parent().parent().parent().parent().removeClass("mm-active");
			});
			$("#side-menu a").each(function () {
				var pageUrl = window.location.href;
				if (this.href == pageUrl){
					$(this).attr("aria-expanded", true);
					$(this).parent().addClass("mm-active"); // add active to li of the current link
					$(this).parent().parent().addClass("mm-show");
					//$(this).parent().parent().prev().addClass("active"); // add active class to an anchor
					$(this).parent().parent().prev().attr("aria-expanded", true);
					$(this).parent().parent().parent().addClass("mm-active");
					$(this).parent().parent().parent().parent().addClass("mm-show"); // add active to li of the current link
					$(this).parent().parent().parent().parent().prev().attr("aria-expanded", true);
					$(this).parent().parent().parent().parent().parent().addClass("mm-active");
					return;
				}
				// else{
				//     //$(this).addClass("active");
				//     $(this).attr('aria-expanded', false);
				//     $(this).parent().removeClass("mm-active"); // add active to li of the current link
				//     $(this).parent().parent().removeClass("mm-show");
				//     //$(this).parent().parent().prev().addClass("active"); // add active class to an anchor
				//     $(this).parent().parent().prev().attr('aria-expanded', false);
				//     $(this).parent().parent().parent().removeClass("mm-active");
				//     $(this).parent().parent().parent().parent().removeClass("mm-show"); // add active to li of the current link
				//     $(this).parent().parent().parent().parent().prev().attr('aria-expanded', false);
				//     $(this).parent().parent().parent().parent().parent().removeClass("mm-active");
				// }
			});
			//$(this).addClass("active");
            
		};
		return sideMenuLinksHelper;
	}
	//define globally if it doesn't already exist
	if (typeof (sideMenuLinksHelper) === "undefined") {
		window.sideMenuLinksHelper = defineSideMenuLinksHelper();
	} else {
		console.log("sideMenuLinksHelper already defined.");
	}
})(window);